import {
  BasicResponse,
  Coordinates,
  DeviceCountDataInterval,
  MainDeviceType,
} from '../../types';
import { DasEndpoint } from '../../types/Device';

import DsmAxios from '../DsmAxios';

export const transferEndpoints = ({
  destinationUserId,
  endpointIds,
}: {
  destinationUserId: string;
  endpointIds: string[];
}) => {
  return DsmAxios.post('v1/transfer/endpoints', {
    destinationUserId,
    endpointIds,
  });
};

export const transferLocators = ({
  destinationUserId,
  dasbeaconIds,
  bleAoaIds,
  uwbAoaIds,
}: {
  destinationUserId: string;
  dasbeaconIds: string[];
  bleAoaIds: string[];
  uwbAoaIds: string[];
}) => {
  return DsmAxios.post('v1/transfer/locators', {
    destinationUserId,
    dasbeaconIds,
    bleAoaIds,
    uwbAoaIds,
  });
};

export const getOnlineDeviceCountInterval = ({
  fromDate,
  toDate,
  timeZone,
  endpointType,
  projectId,
  interval,
  dasIds,
}: {
  projectId: string;
  endpointType: MainDeviceType;
  fromDate?: string;
  toDate?: string;
  timeZone?: string;
  dasIds?: string;
  interval: 'month' | 'hour' | 'day' | 'minute';
}) => {
  return DsmAxios.get<BasicResponse<DeviceCountDataInterval>>(
    `v1/projects/${projectId}/stats/online`,
    {
      params: {
        fromDate,
        toDate,
        timeZone,
        endpointType,
        interval,
        dasIds,
      },
    },
  );
};

export const addEndPointToProject = ({
  projectId,
  endpointId,
}: {
  projectId: string;
  endpointId: string;
}) => {
  return DsmAxios.post(`v1/projects/${projectId}/endpoints`, {
    endpointId,
  });
};

export const removeEndPointFromProject = ({
  projectId,
  endpointId,
}: {
  projectId: string;
  endpointId: string;
}) => {
  return DsmAxios.delete(`v1/projects/${projectId}/endpoints/${endpointId}`);
};

export const updateEndPointFromProject = ({
  projectId,
  endpointId,
  data,
}: {
  projectId: string;
  endpointId: string;
  data: {
    name?: string;
    coordinates?: Coordinates | null;
    isDefaultWbgt?: boolean;
  };
}) => {
  return DsmAxios.patch(
    `v1/projects/${projectId}/endpoints/${endpointId}`,
    data,
  );
};

type GetEndpointParams = {
  id: string;
};

export const getEndpoint = (params: GetEndpointParams) => {
  return DsmAxios.get<BasicResponse<DasEndpoint>>(
    `v1/projects/which/devices/${params.id}`,
  );
};

export const getEndpointByDasId = ({
  projectId,
  dasId,
}: {
  projectId: string;
  dasId: string;
}) => {
  return DsmAxios.get<BasicResponse<DasEndpoint & { isDefaultWbgt: boolean }>>(
    `v1/projects/${projectId}/endpoints/${dasId}`,
  );
};
